module.exports = __webpack_public_path__ + "static/media/covi_per_don_tou.1a4ed66f.png";